import { InputContainer } from '../../global/styles';
import { Input, Label } from '../../global/styles';

interface Props {
	value: string;
	onChange: (value: string) => void;
}

export default function NameInput({ onChange, value }: Props) {
	return (
		<InputContainer>
			<Label>Custom name (optional)</Label>
			<Input value={value} onChange={e => onChange(e.target.value)} />
		</InputContainer>
	);
}
